import { render, staticRenderFns } from "./lianjie.vue?vue&type=template&id=3406176f&scoped=true&"
import script from "./lianjie.vue?vue&type=script&lang=ts&"
export * from "./lianjie.vue?vue&type=script&lang=ts&"
import style0 from "./lianjie.vue?vue&type=style&index=0&id=3406176f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3406176f",
  null
  
)

export default component.exports